// @flow
import moment from 'moment'
import { LOCATION_CHANGE } from 'connected-react-router'

import {
  GET_STUDENT_PROFILE_FAILURE,
  GET_STUDENT_PROFILE_REQUEST,
  GET_STUDENT_PROFILE_SUCCESS,
  TOGGLE_ATTENDANCE_VIEW,
  SET_STUDENT_PROFILE_DATE_RANGE,
  WEEKLY_ENGAGEMENT_TOGGLE
} from '../actions/studentprofile'

const initialState: {
  isFetching: boolean,
  student: null,
  courses: Array<Object>,
  reviews: Array<Object>,
  startDate: moment,
  endDate: moment,
  attendanceViewToggle: boolean,
  weeklyEngagementToggle: boolean
} = {
  isFetching: false,
  student: null,
  courses: [],
  reviews: [],
  startDate: moment().subtract(8, 'weeks').add(1, 'days').format('YYYY-MM-DD'),
  endDate: moment().format('YYYY-MM-DD'),
  attendanceViewToggle: true,
  weeklyEngagementToggle: true
}

export function studentprofile(
  state: Object = initialState,
  action: Object
): Object {
  switch (action.type) {
    case GET_STUDENT_PROFILE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        student: null,
        courses: []
      })

    case GET_STUDENT_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        student: action.student,
        courses: action.courses,
        reviews: action.reviews
      })

    case GET_STUDENT_PROFILE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        student: null,
        courses: []
      })

    case TOGGLE_ATTENDANCE_VIEW:
      return Object.assign({}, state, {
        attendanceViewToggle: action.isCourseViewToggled
      })

    case WEEKLY_ENGAGEMENT_TOGGLE:
      return Object.assign({}, state, {
        weeklyEngagementToggle: action.isWeeklyEngagementToggle
      })

    case SET_STUDENT_PROFILE_DATE_RANGE:
      return Object.assign({}, state, {
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      })
    // // reset this reducer when navigating away, prevents duplicate data fetches when returning
    // case LOCATION_CHANGE:
    //   return Object.assign({}, state, initialState)

    default:
      return state
  }
}
